import React from "react";
import { FaIcon } from '../../../shared/components'

const SubcategoryRow = ({ subcategory, provided, onEdit, onDelete, onCheckboxClick, canDashboardItems }) => (
  <tr
    className="subcategory-row hoverable-row"
    ref={provided.innerRef}
    {...provided.draggableProps}
    {...provided.dragHandleProps}
  >
    <td>
      <div
        className={`icheckbox_square-orange icheck-item ${subcategory.checked ? 'checked' : ''} ${subcategory.default ? 'disabled' : ''}`}
        onClick={onCheckboxClick}
      >
        <input
          id={`checkbox${subcategory.id}`}
          className="i-checks icheck-input"
          type="checkbox"
          checked={subcategory.checked}
          readOnly
        />
      </div>
    </td>
    <td className="add-margin-right-10">
      <i className="fa fa-bars drag_handle ui-sortable-handle"></i>
    </td>
    <td>
      {subcategory.name.length > 60 ? subcategory.name.slice(0, 60) + '…' : subcategory.name}
      {subcategory.name === 'Switch Accounts' &&
        <i className="gga-info-circle" title={window.I18n.t('mobile_app_dashboard.home.switch_accounts')}></i>
      }
    </td>
    <td>
      {!subcategory.system_field && canDashboardItems && (
        <div className="actions">
          <a onClick={(e) => { e.stopPropagation(); onEdit(); }} className="edit-action add-margin-right-10">
            <FaIcon icon='edit' />
            {window.I18n.t('mobile_app_dashboard.menu.edit')}
          </a>
          {!subcategory.default && (
            <>
              <span>• </span>
              <a onClick={(e) => { e.stopPropagation(); onDelete(); }} className="remove-action">
                <FaIcon icon='trash-alt-o' />
                {window.I18n.t('mobile_app_dashboard.menu.remove')}
              </a>
            </>
          )}
        </div>
      )}
    </td>
  </tr>
);

export default SubcategoryRow;
